@let lines = lines$ | async;
@if (lines?.length) {
    <ui-table class="medium-margin" [dataSource]="lines">
        @for (memberCode of orderedColumnMemberCodes$ | async; track memberCode) {
            <ng-container [uiColumnDef]="memberCode" [alignment]="formattingInformation[memberCode]?.columnAlignment">
                <ui-header-cell *uiHeaderCellDef> {{ formattingInformation[memberCode]?.headerName }}</ui-header-cell>
                <ui-cell *uiCellDef="let line">{{ line[memberCode] | async }}</ui-cell>
            </ng-container>
        }
        <ui-header-row *uiHeaderRowDef="orderedColumnMemberCodes$ | async" />
        <ui-row *uiRowDef="let row; columns: orderedColumnMemberCodes$ | async" />
    </ui-table>
}
@if (lines?.length && !(isResultCountLimited$ | async)) {
    <shared-ui-paginator
        [elementCount]="totalElements ?? 0"
        [page]="paginationParams$.getValue().page"
        [pageSize]="paginationParams$.getValue().pageSize"
        (paginationParamsChange)="setPagination($event)"
    />
}

@if (!lines?.length) {
    <loading-and-error class="no-data" [hasNoData]="true" />
}
